import { RouteView, PageView } from '../layouts'
export const im = {
    path: '/im',
    name: 'BaseForm',
    component: PageView,
    meta: { title: 'IM管理', icon: 'message', isMenuShow: true,permission:'im'},
    children: [
        {
            path: '/im/groupChat',
            name: 'BaseForm',
            component: () => import('../views/im/groupChat.vue'),
            meta: { title: '群聊管理', keepAlive: false, isMenuShow: true,permission:'im:group' },
        },
        {
            path: '/im/privateChat',
            name: 'BaseForm',
            component: () => import('../views/im/privateChat.vue'),
            meta: { title: '私聊管理', keepAlive: false, isMenuShow: true,permission:'im:sim' },
        },
        {
            path: '/im/sensitiveWords',
            name: 'BaseForm',
            component: () => import('../views/im/words.vue'),
            meta: { title: '关键字词库', keepAlive: false, isMenuShow: true,permission:'im:sim' },
        },
        {
            path: '/im/complainWords',
            name: 'BaseForm',
            component: () => import('../views/im/complainWords.vue'),
            meta: { title: '抱怨词库', keepAlive: false,permission:'im:sim:chat' },
        },
        {
            path: '/im/saleWords',
            name: 'BaseForm',
            component: () => import('../views/im/saleWords.vue'),
            meta: { title: '销售词库', keepAlive: false,permission:'im:sim:chat' },
        },
        {
            path: '/im/addSensitive',
            name: 'BaseForm',
            component: () => import('../views/im/addSensitive.vue'),
            meta: { title: '添加关键字', keepAlive: false,permission:'im:sim:chat' },
        },
        {
            path: '/im/chat',
            name: 'BaseForm',
            component: () => import('../views/im/chat1.vue'),
            meta: { title: '聊天', keepAlive: false,permission:'im:sim:chat' },
        },
        {
            path: '/im/chatgroupTim',
            name: 'BaseForm',
            component: () => import('../views/im/chatgroupTim.vue'),
            meta: { title: '群聊', keepAlive: false,permission:'im:sim:chat' },
        },

        
        {
            path: '/im/chatgroup',
            name: 'BaseForm',
            component: () => import('../views/im/chatgroup1.vue'),
            meta: { title: '群聊', keepAlive: false,permission:'im:group:chat' },
        },
        {
            path: '/im/inviteToGroup',
            name: 'BaseForm',
            component: () => import('../views/im/inviteToGroup.vue'),
            meta: { title: '加入群聊', keepAlive: false,permission:'im:group:chat:add' },
        },
        {
            path: '/im/grouphistory',
            name: 'BaseForm',
            component: () => import('../views//im/grouphistory.vue'),
            meta: { title: '群聊天记录', keepAlive: false,permission:'im:sim:history' },
        },
        {
            path: '/im/privatehistory',
            name: 'BaseForm',
            component: () => import('../views/im/privatehistory.vue'),
            meta: { title: '私聊天记录', keepAlive: false,permission:'im:group:history' },
        },

    ]
}
